/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import "react-datepicker/dist/react-datepicker.css";
import PageHeader from "../../components/PageHeader";
import { useHistory } from "react-router-dom";
import queryString from "query-string";
import { getCareCompany } from "../../apis/admin/companies";
import CareCompanyInfo from "../../components/CareCompany/CareCompanyInfo";
import CareCompanyAddInfo from "../../components/CareCompany/CareCompanyAddInfo";
import CareCompanyPersonInCharge from "../../components/CareCompany/CareCompanyPersonInCharge"
import CareCompanySchedule from "../../components/CareCompany/CareCompanySchedule";
import { isEmpty } from "lodash";
import Loading from "../../components/Loading";

import Icon from "../../components/Icon";
import warningIcon from "../../assets/images/icon/warning-icon.svg";

//company,
//managerCompany,
const CareCompany = (props) => {
  const history = useHistory();
  const [activeTab, setActiveTab] = useState("info");
  
  const [isManager, setManager] = useState(false);
  const [myCareCompany, setMyCareCompany] = useState(null);
  const [myCompany, setMyCompany] = useState(null);

  const { user, company, companies } = useSelector(
    (store) => ({
      user: store.Profile.user,
      company: store.Profile.company,
      companies: store.Data.companies,
    }),
    shallowEqual
  );

  const _setActiveTab = (value) => {
    history.push(`/managing/carecompany?tab=${value}`);
  }

  const tabList = [
    {
      label: "고객 정보",
      action: _setActiveTab,
      value: 'info',
    },
    {
      label: "추가 정보",
      action: _setActiveTab,
      value: 'addInfo',
    },
    {
      label: "담당자",
      action: _setActiveTab,
      value: 'clientManager',
    },
    {
      label: "메모",
      action: _setActiveTab,
      value: 'scheduleMemo',
    }
  ];

  useEffect(() => {
    const query = queryString.parse(history.location.search);
    setActiveTab(query.tab || tabList[0].value);
  }, [history.location])

  useEffect(() => {
    if (!isEmpty(company) && !isEmpty(user)) {
      //console.log("company: ", company, user.managerCompanyIdx)
      const managerCompany = companies.find((com) => com.companyIdx === user.managerCompanyIdx)
      setMyCompany(managerCompany)

      setManager(false)

      if ( managerCompany.companyIdx !== company.companyIdx) {
        getCareCompany(managerCompany.companyIdx, managerCompany.type, company.companyIdx).then(res => {
          //console.log("res: ", res.data.company)
          setMyCareCompany(res.data.company)
        })
        .catch((err) => {
          console.log(err);
        });
      } else {
        setManager(true)
      }
    }
  }, [companies, user])
  
  return (
    
    <div className="care-company">
      <>
        <PageHeader
          title={"고객 정보 관리"}
          activeTab={activeTab}
          tabList={tabList}
        />

        { isManager && (
          <div className="care-company-wrap">
            <div className="care-company-text-wrap">
              <Icon src={warningIcon} />
              <span className="care-company-text">
                {"고객사가 아닙니다."}
              </span>
            </div>
          </div>
        )}

        { myCareCompany && !isManager &&
          <>
          {
            (activeTab === 'info') &&
            <CareCompanyInfo company={myCareCompany} managerCompany={myCompany} ></CareCompanyInfo>
          }
          {
            (activeTab === 'addInfo') &&
            <CareCompanyAddInfo company={myCareCompany} managerCompany={myCompany}></CareCompanyAddInfo>
          }
          {
            (activeTab === 'clientManager') &&
            <CareCompanyPersonInCharge company={myCareCompany} managerCompany={myCompany}></CareCompanyPersonInCharge>
          }
          {
            (activeTab === 'scheduleMemo') &&
            <CareCompanySchedule company={myCareCompany} managerCompany={myCompany}></CareCompanySchedule>
          }
          </>
        }
        { !myCareCompany && !isManager && 
          <><Loading></Loading></>
        }
      </>
    </div>
  )
}

export default CareCompany;
